import React from 'react'
import isEmpty from 'lodash/fp/isEmpty'
import { useHistory } from 'react-router-dom'
import Section from 'components/ui/Section'
import useKidsHook from './Dashboard.use'
import Avatars from 'assets/avatars'
import { ReactComponent as Unlock } from 'assets/unlock.svg'

const Dashboard = () => {
  const history = useHistory()
  const { data, error, fetching } = useKidsHook()

  const onClickKid = (id) => history.push(`/kids/${id}`)

  // TODO - if isFetching show skeleton component
  return !fetching && !error && !isEmpty(data) ? (
    <Section>
      <h1 className="mb-12 text-6xl font-hairline tracking-wide text-center text-gray-300">
        Lets make today great!
      </h1>

      <div className="flex flex-wrap justify-center">
        {data.map(({ id, name, balance, avatar }) => (
          <div
            key={id}
            onClick={() => onClickKid(id)}
            className="relative flex items-center w-1/2 px-8 py-6 mx-1 mb-8 transition-all duration-500 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-lg"
          >
            <div className="w-20 h-20 pt-2 mr-4 overflow-hidden rounded-full shadow-xs bg-gray-50">
              <img src={Avatars[avatar]} alt="Avatar" />
            </div>
            <div className="mr-auto text-3xl font-light text-gray-700">
              {name}
            </div>
            <div className="flex items-center px-4 py-2 bg-pink-400 rounded-full">
              <div className="font-bold text-white">{balance} Points</div>
            </div>
          </div>
        ))}
      </div>

      <div
        title="Enter Parent Mode"
        onClick={() => history.push('/parents')}
        className="absolute bottom-0 right-0 w-20 h-20 p-4 mb-8 mr-8 text-gray-300 transition-all duration-300 bg-white rounded-full shadow-sm cursor-pointer hover:shadow-lg hover:text-gray-500"
      >
        <Unlock className="fill-current" />
      </div>
    </Section>
  ) : null
}

export default Dashboard
